import React, { FunctionComponent } from "react";
import { Card, CardContent, Typography } from "@mui/material";
import styles from "./GenericSelectCard.module.css";

import { Topic } from "../../context/ConfigContext/types";
import { ClientAccess } from "../../context/ClientAccessContext/types";

interface GenericSelectCardProps {
  item: ClientAccess | Topic;
  onClick: () => void;
}

const GenericSelectCard: FunctionComponent<GenericSelectCardProps> = ({ item, onClick }) => {
  const getCardText = () => {
    return "clientName" in item
      ? item.clientName.charAt(0).toUpperCase() + item.clientName.slice(1)
      : item.name.charAt(0).toUpperCase() + item.name.slice(1);
  };
  return (
    <Card className={styles.card} onClick={onClick}>
      <CardContent className={styles.card_content}>
        <Typography variant="subtitle2" color="text.primary">
          {getCardText()}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default GenericSelectCard;
